

























import Vue, { PropType } from 'vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import { User } from '@/types/generated/graphql'

export default Vue.extend({
  name: 'EmailInfo',
  components: { XCard },
  props: {
    user: {
      type: Object as PropType<User>,
      required: true,
    },
  },
})
